import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import Profile from "views/admin/profile";
import DataTables from "views/admin/tables";
import CafHubPage from "views/admin/folios/CafHubPage";

// Auth Imports
import SignIn from "views/auth/SignIn";
import ForgotPassword from "views/auth/ForgotPassword";
import ResetPassword from "views/auth/ResetPassword";

// Icon Imports
import {
  MdHome,
  MdBarChart,
  MdInventory2,
  MdPerson,
  MdLock,
  MdReceiptLong,
  MdMenuBook,
} from "react-icons/md";
import DteComprasPage from "views/admin/compras/DteComprasPage";
import DteLibrosPage from "views/admin/libros/DteLibrosPage";

/** `claveI18n`: clave del diccionario para mostrar el nombre traducido. `name` se
 * conserva como respaldo y porque otras partes lo comparan. */

/** Opcional: `sidebarAmbiente`: "certificacion" | "produccion" — visible solo si ese ambiente coincide con el perfil DTE único. Sin esta propiedad: siempre en el menú. */

const routes = [
  {
    name: "Main Dashboard",
    layout: "/admin",
    path: "default",
    claveI18n: "menu.dashboard",
    icon: <MdHome className="w-6 h-6" />,
    component: <MainDashboard />,
  },
  {
    name: "DTE emitidos",
    layout: "/admin",
    path: "data-tables",
    claveI18n: "menu.emitidos",
    icon: <MdBarChart className="w-6 h-6" />,
    component: <DataTables />,
  },
  {
    name: "DTE Compras",
    layout: "/admin",
    path: "dte-compras",
    claveI18n: "menu.compras",
    icon: <MdReceiptLong className="w-6 h-6" />,
    component: <DteComprasPage />,
  },
  {
    name: "DTE Libros",
    layout: "/admin",
    path: "dte-libros",
    claveI18n: "menu.libros",
    icon: <MdMenuBook className="w-6 h-6" />,
    component: <DteLibrosPage />,
  },
  {
    name: "CAF",
    layout: "/admin",
    path: "caf",
    claveI18n: "menu.caf",
    icon: <MdInventory2 className="w-6 h-6" />,
    component: <CafHubPage />,
  },
  {
    name: "Profile",
    layout: "/admin",
    path: "profile",
    claveI18n: "menu.perfil",
    icon: <MdPerson className="w-6 h-6" />,
    component: <Profile />,
  },
  {
    name: "Forgot password",
    layout: "/auth",
    path: "forgot-password",
    icon: <MdLock className="w-6 h-6" />,
    component: <ForgotPassword />,
    hideInSidebar: true,
  },
  {
    name: "Reset password",
    layout: "/auth",
    path: "reset-password",
    icon: <MdLock className="w-6 h-6" />,
    component: <ResetPassword />,
    hideInSidebar: true,
  },
  {
    name: "Sign In",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="w-6 h-6" />,
    component: <SignIn />,
    hideInSidebar: true,
  },
];
export default routes;
